<template>
    <v-dialog v-model="dialog" max-width="600px">
        <v-card :loading="fetchData">
            <v-form v-model="isValid" ref="form" @submit.prevent="saveData" id="form" >
                <v-card-title>
                    {{isEdit ? "Thay đổi" :"Thêm"}} phân công nhân viên
                    <v-spacer></v-spacer> <v-icon small @click="dialog=false"> mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-btn color="info" @click="employeeDialog = true" text small>Chọn nhân viên</v-btn>
                            <div  v-if="form.quitEmployeeCode" class="subtitle-1"><b>{{ form.quitEmployeeCode }}</b> - {{ form.employeeName }}</div>
                        </v-col>
                        <v-col cols="12">
                            <date-picker2 label="Ngày nghỉ việc" v-model="form.quitDate" :width="800" :range="false" :rules="[v=>!!v||'Nhập dữ liệu']"></date-picker2>
                        </v-col>
                        <v-col cols="12">
                            <v-select :items="quitTypes" label="Loại  phiếu" persistent-placeholder item-text="name" item-value="code" v-model="form.quitTypeCode"
                            @change="setTerm()" :rules="[v=>!!v||'Nhập dữ liệu']"></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-if="form.quitTypeCode === 'TS' " label="Ngày dự sinh" persistent-placeholder v-model="form.dueDate" type="date"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <p>{{ this.term }}</p>
                            <v-checkbox v-if="term" v-model="form.isAgreeTerm" :true-value="1" :false-value="0" label="Tôi đồng ý với điều khoản trên"></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea label="Lý do xin nghỉ" v-model="form.quitReason" outlined :rules="[v=>!!v||'Nhập dữ liệu']">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="success" type="submit"> Lưu</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-form>
        </v-card>
        <employee-dialog v-model="employeeDialog" @input="setEmployee">
        </employee-dialog>
    </v-dialog>
</template>
<script>
import http from '@/components/services/http-common';
import moment from 'moment/moment';
import EmployeeDialog from '@/components/Crud/Prompt/EmployeeDialog'
export default {
    components: {
        "employee-dialog": EmployeeDialog
    },
    props:["value", "item", "employee"],
    watch:{
        employee(val) {
            console.log("has employee");
        },
        value: {
            handler(val){
                if(val)
                {
                    if(this.isEdit)
                        this.fetch();
                }
                else{
                    this.close();
                }
            }
        },

    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",

            isValid: true,
            fetchData: false,
            form: {
                quitEmployeeCode: "",
                employeeName: "",
                quitDate: null,
                quitReason:"",
                quitTypeCode: '',
                isAgreeTerm: 0,
                dueDate: null
            },
            defaultForm:{
                quitEmployeeCode: "",
                employeeName: "",
                quitDate: null,
                quitReason:"",
                quitTypeCode: '',
                isAgreeTerm: 0,
                dueDate: null
            },
            quitReasons: [
                "Khác",
            ],
            quitTypes: [],
            term: '',
            employeeDialog: false,
        }
    },
    methods: {
        fetch(employee = false){
            this.fetchData =true;
            return http.get(this.ROOT_URL+this.item.code).then(res => {
                this.form = Object.assign({}, res.data);
                this.fetchData =false;
            })
        },
        getTypes() {
            return http.get(this.ROOT_URL+"types").then(res => res.data).then(d => {
                this.quitTypes = [...d.data]
            })
        },
        setTerm() {
            let selected = this.form.quitTypeCode
            this.term = this.quitTypes.find(x=>x.code == selected)?.term
        },

        setEmployee(e) {
            var employeeCode = e[0].code
            var employeeName = e[0].name
            this.form.quitEmployeeCode = employeeCode
            this.form.employeeName = employeeName
            this.employeeDialog = false
        },

        saveData() {
            this.$refs.form.validate();
            if(this.isValid)
            {
                if(!this.isEdit){
                    if(this.form.isAgreeTerm ==0) {
                        alert("Bạn chưa đồng ý với các điều kiện trên")
                        return
                    }
                    if(this.form.quitTypeCode == "TS" && !this.form.dueDate ) {
                        alert("Bạn nhập ngày dự sinh khi ở trạng thái thai sản")
                        return
                    }
                    return http.post(this.ROOT_URL+"personal", this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }else {
                    alert("not implemented")
                    return false
                    return http.put(this.ROOT_URL+ this.item.code, this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }
            }
        },
        close(){
            this.form = Object.assign({}, this.defaultForm);
            this.$refs.form.resetValidation();
            this.terms = ''
            this.fetchData=false;
        }
    },
    created() {
        this.getTypes()
    }
}
</script>